import React, { useEffect, useState } from "react";
import {
  getCountry,
  getDomain,
  getHeight,
  getMaritualStatus,
  getCast,
  getCity,
  getState,
  getReligion,
  getEducation,
  getOccupation,
  getProfileById,
  getAllReligion,
  getAllIncome,
  getSearch,
  getReligionByIds,
  getCasteByIds,
  getMultipleState,
  getMultipleCity,
} from "../../../asiosConfig";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Autocomplete, TextField, Checkbox, ListItemText } from "@mui/material";
import { logEvent } from "firebase/analytics";
import { analytics } from "../../../services/firebaseConfig";

import { searchMasterCache } from "../../../Component/searchMasterCache";

export const Search = () => {
  const [maritalStatus, setMaritalStatus] = useState([]);
  const [country, setCountry] = useState([]);
  const [height, setHeight] = useState([]);
  const [religion, setReligion] = useState([]);
  const [occupation, setOccupation] = useState([]);
  const [education, setEducation] = useState([]);
  const [income, setIncome] = useState([]);
  const [domain, setDomain] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [religionList, setReligionList] = useState([]);
  const [castList, setCastList] = useState([]);
  const navigate = useNavigate();
  const [profileId, setProfileId] = useState("");
  const [selectedCriteria, setSelectedCriteria] = useState({});
  const [page, setPage] = useState(1);
  const indiaId = 233;
  const gender = localStorage.getItem("gender");

  // useEffect(() => {
  //   if (!gender) return;

  //   // Backend expects opposite gender search
  //   const defaultPrefix = gender === "M" ? "F" : "M";

  //   setProfileId(defaultPrefix);
  // }, [gender]);

  // const isMemberSearchEnabled = profileId.trim().length > 0;

  const isMemberSearchEnabled = profileId.length >= 5;

  const initialValues = {
    domain: "",
    city: "",
    state: "",
    country: indiaId,
    income: "",
    cast: "",
    religion: "",
    citizenship: indiaId,
    maritalStatus: [],
    // tokan: localStorage.getItem('token'),
    user_id: localStorage.getItem("user_id"),
  };

  useEffect(() => {
    if (!gender) return;

    const minAge = gender === "F" ? 21 : 18;

    setSelectedCriteria((prev) => {
      const updated = { ...prev };

      if (updated.ageMin && updated.ageMin < minAge) {
        delete updated.ageMin;
      }

      if (updated.ageMax && updated.ageMax < minAge) {
        delete updated.ageMax;
      }

      return updated;
    });
  }, [gender]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // ✅ Serve from cache if available
        if (searchMasterCache.maritalStatus) {
          setMaritalStatus(searchMasterCache.maritalStatus);
          setHeight(searchMasterCache.height);
          setCountry(searchMasterCache.country);
          setDomain(searchMasterCache.domain);
          setEducation(searchMasterCache.education);
          setOccupation(searchMasterCache.occupation);
          setReligion(searchMasterCache.religion);
          setIncome(searchMasterCache.income);
          return;
        }

        // ❗ Fetch ONLY once
        const [
          maritalResponse,
          heightResponse,
          countryResponse,
          domainResponse,
          educationResponse,
          occupationResponse,
          religionResponse,
          incomeResponse,
        ] = await Promise.all([
          getMaritualStatus(),
          getHeight(),
          getCountry(),
          getDomain(),
          getEducation(),
          getOccupation(),
          getAllReligion(),
          getAllIncome(),
        ]);

        // ✅ Save to cache
        searchMasterCache.maritalStatus = maritalResponse.data;
        searchMasterCache.height = heightResponse.data;
        searchMasterCache.country = countryResponse.data.data;
        searchMasterCache.domain = domainResponse.data.data;
        searchMasterCache.education = educationResponse.data.data;
        searchMasterCache.occupation = occupationResponse.data.data;
        searchMasterCache.religion = religionResponse.data;
        searchMasterCache.income = incomeResponse.data.data;

        // ✅ Update state
        setMaritalStatus(searchMasterCache.maritalStatus);
        setHeight(searchMasterCache.height);
        setCountry(searchMasterCache.country);
        setDomain(searchMasterCache.domain);
        setEducation(searchMasterCache.education);
        setOccupation(searchMasterCache.occupation);
        setReligion(searchMasterCache.religion);
        setIncome(searchMasterCache.income);
      } catch (error) {
        toast.error("Error Fetching Data");
      }
    };

    fetchData();
  }, []);

  console.log(selectedCriteria);

  useEffect(() => {
    if (initialValues.country) {
      fetchState(initialValues.country);
    }
  }, [initialValues.country]);

  useEffect(() => {
    if (initialValues.state) {
      fetchCity(initialValues.state);
    }
  }, [initialValues.state]);

  const fetchState = async (country_id) => {
    try {
      const response = await getMultipleState({ ids: country_id });
      setStateList(response.data);
    } catch (error) {
      console.error("Error fetching State:", error);
    }
  };

  const fetchCity = async (state_id) => {
    try {
      const response = await getMultipleCity({ ids: state_id });
      setCityList(response.data);
    } catch (error) {
      console.error("Error fetching City:", error);
    }
  };

  const fetchReligion = async (Domain_id) => {
    try {
      const response = await getReligionByIds({ ids: Domain_id });
      setReligionList(response.data);
    } catch (error) {
      console.error("Error fetching Religion:", error);
    }
  };

  const fetchCast = async (religion_id) => {
    try {
      const response = await getCasteByIds({ ids: religion_id });
      setCastList(response.data);
    } catch (error) {
      console.error("Error fetching Caste:", error);
    }
  };

  const handleCountryChange = (event, value) => {
    if (value) {
      const country_id = value.map((item) => item.value);
      initialValues.country = country_id;
      initialValues.state = "";
      initialValues.city = "";
      fetchState(country_id);
    } else {
      initialValues.country = "";
      initialValues.state = "";
      initialValues.city = "";
    }
  };

  const handleStateChange = (event, value) => {
    const state_id = value.map((item) => item.value);
    initialValues.state = state_id;
    initialValues.city = "";
    fetchCity(state_id);
  };

  const handleDomainChange = (event, value) => {
    const Domain_id = value.map((item) => item.value);
    initialValues.domain = Domain_id;
    initialValues.religion = "";
    initialValues.cast = "";
    fetchReligion(Domain_id);
  };

  const handleReligionChange = (event, value) => {
    const religion_id = value.map((item) => item.value);
    initialValues.religion = religion_id;
    initialValues.cast = "";
    fetchCast(religion_id);
  };

  const handleProfileSearch = async (profileId) => {
    try {
      logEvent(analytics, "view_profile", {
        viewed_profile_id: profileId,
        profile_viewer_id: localStorage.getItem("user"),
        timestamp: new Date().toISOString(),
      });
      console.log("profileId", profileId);
      navigate("/profile-view", { state: { username: profileId } });
    } catch (error) {
      toast.error("Something Went Wrong:", error);
    }
  };

  const handleSearch = async () => {
    try {
      const payload = {
        pagination: {
          page,
          limit: 10,
        },
      };

      if (!isAgeRangeValid()) {
        toast.error("Please select both Age Min and Age Max");
        return;
      }

      if (!isHeightRangeValid()) {
        toast.error("Please select both Height Min and Height Max");
        return;
      }

      if (selectedCriteria.ageMin != null) {
        payload.ageMin = selectedCriteria.ageMin;
      }

      if (selectedCriteria.ageMax != null) {
        payload.ageMax = selectedCriteria.ageMax;
      }

      if (selectedCriteria.heightMin) {
        payload.heightMin = selectedCriteria.heightMin.value;
      }

      if (selectedCriteria.heightMax) {
        payload.heightMax = selectedCriteria.heightMax.value;
      }

      if (selectedCriteria.maritalStatus?.length) {
        payload.maritalStatus = selectedCriteria.maritalStatus;
      }

      if (selectedCriteria.religion?.length) {
        payload.religions = selectedCriteria.religion.map((i) => i.value);
      }

      if (selectedCriteria.cast?.length) {
        payload.castes = selectedCriteria.cast.map((i) => i.value);
      }

      if (selectedCriteria.country?.length) {
        payload.country = selectedCriteria.country.map((i) => i.value);
      }

      if (selectedCriteria.state?.length) {
        payload.state = selectedCriteria.state.map((i) => i.value);
      }

      if (selectedCriteria.city?.length) {
        payload.city = selectedCriteria.city.map((i) => i.value);
      }

      if (selectedCriteria.income) {
        payload.income = [selectedCriteria.income.value];
      }

      if (selectedCriteria.education?.length) {
        payload.education = selectedCriteria.education.map((i) => i.value);
      }

      if (selectedCriteria.occupation?.length) {
        payload.occupation = selectedCriteria.occupation.map((i) => i.value);
      }

      if (selectedCriteria.domain?.length) {
        payload.domain = selectedCriteria.domain.map((i) => i.value);
      }

      console.log("✅ FINAL API PAYLOAD:", payload);

      navigate("/search-result", {
        state: { searchPayload: payload },
      });
    } catch (error) {
      toast.error("Something went wrong while searching");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (profileId.length >= 5) {
      handleProfileSearch(profileId);
      return;
    }

    if (isCriteriaSearchEnabled()) {
      handleSearch();
    }
  };

  const handleMaritalStatusChange = (event, id) => {
    const { checked } = event.target;

    setSelectedCriteria((prev) => {
      let updatedMaritalStatus = prev.maritalStatus || [];

      if (id === 7) {
        // When id 7 (e.g., "All") is selected/unselected
        updatedMaritalStatus = checked
          ? maritalStatus.map((status) => status.id) // Select all
          : []; // Clear all
      } else {
        // For any other id
        if (checked) {
          updatedMaritalStatus = [...updatedMaritalStatus, id].filter(
            (item) => item !== 7,
          ); // Add id and ensure id 7 is removed
        } else {
          updatedMaritalStatus = updatedMaritalStatus.filter(
            (item) => item !== id,
          ); // Remove the id
        }
      }

      return { ...prev, maritalStatus: updatedMaritalStatus };
    });
  };

  const isAgeRangeValid = () => {
    const { ageMin, ageMax } = selectedCriteria;
    return !ageMin && !ageMax
      ? true // age not used
      : ageMin != null && ageMax != null; // both required
  };

  const isHeightRangeValid = () => {
    const { heightMin, heightMax } = selectedCriteria;
    return !heightMin && !heightMax
      ? true // height not used
      : heightMin && heightMax; // both required
  };

  const isCriteriaSearchEnabled = () => {
    const c = selectedCriteria;

    const hasAnyCriteria = Boolean(
      c.ageMin ||
      c.ageMax ||
      c.heightMin ||
      c.heightMax ||
      (c.maritalStatus && c.maritalStatus.length > 0) ||
      (c.domain && c.domain.length > 0) ||
      (c.religion && c.religion.length > 0) ||
      (c.cast && c.cast.length > 0) ||
      (c.country && c.country.length > 0) ||
      (c.state && c.state.length > 0) ||
      (c.city && c.city.length > 0) ||
      (c.education && c.education.length > 0) ||
      (c.occupation && c.occupation.length > 0) ||
      c.income,
    );

    return hasAnyCriteria && isAgeRangeValid() && isHeightRangeValid();
  };

  const saveBtn = (disabled) => ({
    marginTop: 16,
    width: "60%",
    background: disabled
      ? "#E0E0E0"
      : "linear-gradient(90deg, #FFA24C, #FF5C5C)",
    color: disabled ? "#9E9E9E" : "#ffffff",
    textAlign: "center",
    padding: "10px 0",
    borderRadius: "999px", // capsule
    fontWeight: 700,
    fontSize: 18,
    border: "none",
    cursor: disabled ? "not-allowed" : "pointer",
    transition: "all 0.3s ease",
  });

  const minAllowedAge = gender === "F" ? 21 : 18;

  // keeps same upper limit (80) as before
  const ages = Array.from(
    { length: 81 - minAllowedAge },
    (_, i) => minAllowedAge + i,
  );

  // =========================
  // DERIVED OPTIONS (SAFE)
  // =========================

  const filteredMaxAges = selectedCriteria.ageMin
    ? ages.filter((age) => age >= selectedCriteria.ageMin)
    : ages;

  const heightOptions = height.map((item, index) => ({
    value: item.height_id, // keep original string
    label: item.height,
    order: index, // use index for comparison
  }));

  const filteredMaxHeights = selectedCriteria.heightMin
    ? heightOptions.filter((h) => h.order >= selectedCriteria.heightMin.order)
    : heightOptions;

  return (
    <div className="col-lg-9 col-12">
      <div className="editProfileBlock">
        <div className="profileDetailsBlock mt-3">
          <div className="basicDetailTlt">
            <p>Search By Member ID</p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="row justify-content-center align-items-center mb-3 p-4">
              <div className="col-md-6">
                <label className="form-label">
                  Quickly find profiles by unique member ID.
                </label>
                {/* <input type="text" className="form-control" placeholder="Enter profile ID" value={profileId} onChange={(e) => setProfileId(e.target.value)} required /> */}

                {/* <input
                  type="text"
                  className="form-control"
                  placeholder="Enter profile ID"
                  value={profileId}
                  onChange={(e) => {
                    const value = e.target.value.toUpperCase();

                    // Lock first character (M / F)
                    const prefix = gender === "M" ? "F" : "M";

                    // New Regex: Allows A-Z and 0-9. Removes everything else.
                    const idPart = value.replace(/[^A-Z0-9]/g, "");

                    const cleanIdPart = idPart.startsWith(prefix)
                      ? idPart.substring(1)
                      : idPart;

                    setProfileId(prefix + cleanIdPart);
                  }}
                  onKeyDown={(e) => {
                    // Prevent deleting prefix
                    if (profileId.length === 1 && e.key === "Backspace") {
                      e.preventDefault();
                    }
                  }}
                  required
                /> */}

                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Member ID"
                  value={profileId}
                  onFocus={() => {
                    if (!profileId) {
                      const prefix = gender === "M" ? "F" : "M";
                      setProfileId(prefix);
                    }
                  }}
                  // ✅ ADD THIS
                  onBlur={() => {
                    const prefix = gender === "M" ? "F" : "M";
                    if (profileId === prefix) {
                      setProfileId("");
                    }
                  }}
                  onChange={(e) => {
                    const value = e.target.value.toUpperCase();
                    const prefix = gender === "M" ? "F" : "M";

                    const idPart = value.replace(/[^A-Z0-9]/g, "");

                    const cleanIdPart = idPart.startsWith(prefix)
                      ? idPart.substring(1)
                      : idPart;

                    setProfileId(prefix + cleanIdPart);
                  }}
                  onKeyDown={(e) => {
                    if (profileId.length === 1 && e.key === "Backspace") {
                      e.preventDefault();
                    }
                  }}
                  required
                />

                <button
                  type="submit"
                  disabled={!isMemberSearchEnabled}
                  style={saveBtn(!isMemberSearchEnabled)}
                >
                  Search
                </button>
              </div>
            </div>
          </form>
        </div>

        <div className="profileDetailsBlock mt-3">
          <div className="basicDetailTlt">
            <p>Search By Profile Criteria</p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="row mt-3">
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Age Min</label>
                  <Autocomplete
                    options={ages}
                    getOptionLabel={(option) => String(option)}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Age Min" />
                    )}
                    // onChange={(event, value) =>
                    //   setSelectedCriteria((prev) => ({
                    //     ...prev,
                    //     ageMin: value,
                    //   }))
                    // }

                    onChange={(event, value) =>
                      setSelectedCriteria((prev) => {
                        const updated = { ...prev, ageMin: value };

                        // 🔒 Reset ageMax if it becomes invalid
                        if (prev.ageMax && value && prev.ageMax < value) {
                          updated.ageMax = null;
                        }

                        return updated;
                      })
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Age Max</label>
                  <Autocomplete
                    // options={ages}
                    options={filteredMaxAges}
                    getOptionLabel={(option) => String(option)}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Age Max" />
                    )}
                    onChange={(event, value) =>
                      setSelectedCriteria((prev) => ({
                        ...prev,
                        ageMax: value,
                      }))
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Height Min</label>
                  <Autocomplete
                    // options={height.map(item => ({ id: item.height_id, label: item.height }))}
                    options={heightOptions}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Height Min" />
                    )}
                    // onChange={(event, value) =>
                    //   setSelectedCriteria((prev) => ({
                    //     ...prev,
                    //     heightMin: value,
                    //   }))
                    // }

                    onChange={(event, value) =>
                      setSelectedCriteria((prev) => {
                        const updated = { ...prev, heightMin: value };

                        // Reset heightMax if invalid
                        if (
                          prev.heightMax &&
                          value &&
                          prev.heightMax.order < value.order
                        ) {
                          updated.heightMax = null;
                        }

                        return updated;
                      })
                    }
                    // isOptionEqualToValue={(option, value) => option === value}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Height Max</label>

                  <Autocomplete
                    // options={height.map((item) => ({
                    //   value: Number(item.height_id),
                    //   label: item.height,
                    // }))}
                    options={filteredMaxHeights}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Height Max" />
                    )}
                    //                    onChange={(event, value) =>
                    //   setSelectedCriteria((prev) => {
                    //     const updated = { ...prev, heightMin: value };

                    //     // 🔒 Reset heightMax if invalid
                    //     if (
                    //       prev.heightMax &&
                    //       value &&
                    //       prev.heightMax.value < value.value
                    //     ) {
                    //       updated.heightMax = null;
                    //     }

                    //     return updated;
                    //   })
                    // }

                    onChange={(event, value) =>
                      setSelectedCriteria((prev) => ({
                        ...prev,
                        heightMax: value,
                      }))
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <p className="checkTlt">Marital Status</p>
              {maritalStatus.map((status) => (
                <div className="col-md-3" key={status.id}>
                  <div className="form-check">
                    <Checkbox
                      className="form-check-input"
                      checked={
                        selectedCriteria.maritalStatus?.includes(status.id) ||
                        false
                      }
                      onChange={(e) => handleMaritalStatusChange(e, status.id)}
                    />
                    <label
                      className="form-check-label"
                      style={{ marginLeft: "8px" }}
                    >
                      {status.status}
                    </label>
                  </div>
                </div>
              ))}
            </div>
            <div className="row mt-3">
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Domain</label>
                  <Autocomplete
                    multiple
                    options={domain.map((item) => ({
                      value: item.id,
                      label: item.domain,
                    }))}
                    // onChange={handleDomainChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Domain"
                      />
                    )}
                    onChange={(event, value) => {
                      setSelectedCriteria((prev) => ({
                        ...prev,
                        domain: value,
                      }));
                      handleDomainChange(event, value);
                    }}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Religion</label>
                  <Autocomplete
                    multiple
                    options={religionList.map((item) => ({
                      value: item.id,
                      label: item.religion,
                    }))}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Religion"
                      />
                    )}
                    onChange={(event, value) => {
                      setSelectedCriteria((prev) => ({
                        ...prev,
                        religion: value,
                      }));
                      handleReligionChange(event, value);
                    }}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Caste</label>
                  <Autocomplete
                    multiple
                    options={castList.map((item) => ({
                      value: item.id,
                      label: item.caste,
                    }))}
                    renderInput={(params) => (
                      <TextField {...params} variant="outlined" label="Caste" />
                    )}
                    onChange={(event, value) =>
                      setSelectedCriteria((prev) => ({ ...prev, cast: value }))
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Country</label>
                  <Autocomplete
                    multiple
                    options={country.map((item) => ({
                      value: item.id,
                      label: item.country,
                    }))}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Country"
                      />
                    )}
                    onChange={(event, value) => {
                      setSelectedCriteria((prev) => ({
                        ...prev,
                        country: value,
                      }));
                      handleCountryChange(event, value);
                    }}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">State</label>
                  <Autocomplete
                    multiple
                    options={stateList.map((item) => ({
                      value: item.state_id,
                      label: item.state_name,
                    }))}
                    renderInput={(params) => (
                      <TextField {...params} variant="outlined" label="State" />
                    )}
                    onChange={(event, value) => {
                      setSelectedCriteria((prev) => ({
                        ...prev,
                        state: value,
                      }));
                      handleStateChange(event, value);
                    }}
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">City</label>
                  <Autocomplete
                    multiple
                    options={cityList.map((item) => ({
                      value: item.id,
                      label: item.city,
                    }))}
                    renderInput={(params) => (
                      <TextField {...params} variant="outlined" label="City" />
                    )}
                    onChange={(event, value) =>
                      setSelectedCriteria((prev) => ({ ...prev, city: value }))
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Annual Income</label>
                  <Autocomplete
                    options={income.map((item) => ({
                      value: item.tbl_income_id,
                      label: item.income_type,
                    }))}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Annual Income" />
                    )}
                    onChange={(event, value) =>
                      setSelectedCriteria((prev) => ({
                        ...prev,
                        income: value,
                      }))
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.value === value.value
                    }
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Education</label>
                    <Autocomplete
                      multiple
                      options={education.map((item) => ({
                        value: item.id,
                        label: item.education,
                      }))}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="Education"
                        />
                      )}
                      onChange={(event, value) =>
                        setSelectedCriteria((prev) => ({
                          ...prev,
                          education: value,
                        }))
                      }
                      isOptionEqualToValue={(option, value) =>
                        option.value === value.value
                      }
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Profession</label>
                    <Autocomplete
                      multiple
                      options={occupation.map((item) => ({
                        value: item.id,
                        label: item.occupation,
                      }))}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="Profession"
                        />
                      )}
                      onChange={(event, value) =>
                        setSelectedCriteria((prev) => ({
                          ...prev,
                          occupation: value,
                        }))
                      }
                      isOptionEqualToValue={(option, value) =>
                        option.value === value.value
                      }
                    />
                  </div>
                </div>
                <div className="row justify-content-center align-items-center mb-3 p-4">
                  <div className="col-md-6">
                    {/* <button type="submit" className="btn btn-primary formBtn mt-3">Search</button> */}

                    <button
                      type="submit"
                      disabled={!isCriteriaSearchEnabled()}
                      style={saveBtn(!isCriteriaSearchEnabled())}
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};
